<template>
	<div class="pt-2">
		<div class="mx-2">
			<v-select
				:items="appTypes"
				v-model="selectedAppType"
				label="App Type"
				outline
				:color="themeInputColor"
				@change="updateAppType"
			></v-select>
		</div>
		<v-data-table
			:headers="headers"
			:items="dstrTargetGmvData"
			:items-per-page="5"
			class="elevation-1"
		>
			<template v-slot:items="props">
				<tr>
					<td
						v-for="item in fixedHeaders"
						:key="item.value"
						class="text-xs-center"
					>
						{{ props.item[item.value] }}
					</td>
					<td
						v-for="(item, index) in props.item.target"
						:key="`target-${index}`"
						class="text-xs-center"
					>
						{{ item.value }}
					</td>
				</tr>
			</template>
		</v-data-table>
		<label class="pa-2" for="files">Upload a CSV formatted file: </label>
		<v-layout class="pa-3" align-center>
			<v-flex xs6 sm4 md4>
				<input
					ref="inputUpload"
					type="file"
					@change="onFileChange"
					accept=".csv"
					required
					class="input"
				/> </v-flex
			><v-flex xs2 sm1 md1>
				<v-icon class="cancel-icon" @click="clearInput">
					{{ "cancel" }}
				</v-icon>
			</v-flex>
			<v-flex xs4 sm7 md7>
				<v-btn
					depressed
					color="primary"
					class="upload-btn"
					@click="uploadFile()"
					:disabled="!isFileSelected"
				>
					Upload
				</v-btn>
			</v-flex>
		</v-layout>
		<v-layout align-center justify-center>
			<div class="mt-3">
				<a target="_blank" :href="sampleCsv">Download sample file</a>
			</div>
		</v-layout>
		<div v-if="loading" class="overlay">
			<v-progress-circular :indeterminate="true"></v-progress-circular>
		</div>
	</div>
</template>

<script>
import {
	FETCH_ALL_DSTR_TARGETS,
	UPLOAD_MEDIA_TO_SERVER,
	UPDATE_DSTR_CSV_FILEPATH
} from "@/store/action-types";
import { mapState } from "vuex";
let filePayload = null;

export default {
	name: "AddUpdateDstrTarget",
	props: ["title", "themeInputColor", "appType"],
	data() {
		return {
			sampleCsv:
				"https://cdn.sharechat.com/20e4768d_1652863489391_sc.csv",
			dstrTargetGmvData: [{ target: [], startDate: "NA" }],
			dialog: false,
			maxTargetLength: 0,
			isFileSelected: false,
			loading: false,
			uploadKey: "dstrTargetAdmin",
			fixedHeaders: [],
			headers: [],
			selectedAppType: "JEET11",
			appTypes: ["JEET11", "RUMMY"]
		};
	},
	mounted() {
		this.fetchDstrTargetGmvData();
	},
	computed: {
		...mapState({
			ACCESS_TOKEN: state => state.auth.ACCESS_TOKEN,
			alert: state => state.common.alert
		})
	},
	methods: {
		updateAppType() {
			this.fetchDstrTargetGmvData();
		},
		fetchDstrTargetGmvData() {
			this.loading = true;
			this.$store
				.dispatch(FETCH_ALL_DSTR_TARGETS.dispatch, {
					appType: this.selectedAppType
				})
				.then(resp => {
					this.updateHeaderAndData(resp);
				})
				.catch(err => console.log(err))
				.finally(() => {
					this.loading = false;
				});
		},
		updateHeaderAndData(resp) {
			this.dstrTargetGmvData = resp;
			this.maxTargetLength = resp.reduce((acc, curr) => {
				return Math.max(acc, curr.target.length);
			}, 0);
			this.dstrTargetGmvData = this.dstrTargetGmvData.map(item => {
				const fillValueLength =
					this.maxTargetLength - item.target.length;
				return {
					...item,
					target: [
						...item.target,
						...Array(fillValueLength).fill({
							value: "NA"
						})
					]
				};
			});
			this.fixedHeaders = [];
			Object.keys(resp[0] || {}).forEach(header => {
				if (header !== "target") {
					this.fixedHeaders.push({
						text: header,
						value: header,
						align: "center",
						sortable: false
					});
				}
			});
			this.headers = [
				...this.fixedHeaders,
				...Array.from(Array(this.maxTargetLength).keys()).map(
					(item, index) => {
						return {
							text: `Target ${index + 1}`,
							value: `value`,
							align: "center",
							sortable: false
						};
					}
				)
			];
		},
		uploadFile() {
			this.clearInput();
			this.$store
				.dispatch(UPLOAD_MEDIA_TO_SERVER.dispatch, {
					key: this.uploadKey,
					file: filePayload,
					type: "csvUpload"
				})
				.then(data => {
					this.uploadFilePath(data.fileUrl);
				})
				.catch(err => console.log(err));
		},
		uploadFilePath(filePath) {
			this.$store
				.dispatch(UPDATE_DSTR_CSV_FILEPATH.dispatch, {
					appType: this.selectedAppType,
					filePath
				})
				.then(() => {
					this.fetchDstrTargetGmvData();
				})
				.catch(err => console.log(err));
		},
		onFileChange(e) {
			const files = e.target.files || e.dataTransfer.files;
			if (!files.length) return;
			this.isFileSelected = true;
			filePayload = files[0];
		},
		clearInput() {
			this.$refs.inputUpload.value = "";
			this.isFileSelected = false;
		}
	}
};
</script>

<style lang="scss" scoped>
.overlay {
	position: fixed;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	background: rgba(0, 0, 0, 0.5);
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 2;
}
</style>
